<template>
  <div class="vx-card" id="agent-recipient-info">
    <div class="vx-card__body card-body">
      <div class="vx-row" v-if="recipients && recipients.length < 2">
        <div class="vx-col w-full mb-2">
          <vs-button
            @click="addNewInfo = !addNewInfo"
            color="success"
            icon="add"
          >
            {{ $t("AddRecipientInfo") }}
          </vs-button>
        </div>
      </div>
      <form v-if="addNewInfo && recipients.length < 2" class="mb-4">
        <div class="vx-row">
          <div class="vx-col lg:w-1/2 sm:w-1/2 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-model="model.recipient.fullName"
              name="fullName"
              :label="$t('FullName')"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('fullName')">{{
              errors.first("fullName")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/2 sm:w-1/2 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-model="model.recipient.phoneNumber"
              name="phoneNumber"
              :label="$t('PhoneNumber')"
              v-validate="{ regex: '^([0-9]+)$', required: 'true' }"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('phoneNumber')"
              >{{ errors.first("phoneNumber") }}</span
            >
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col lg:w-1/2 sm:w-1/2 w-full">
            <label class="vs-select--label">{{ $t("Province") }}</label>
            <v-select
              label="name"
              :options="allProvinces"
              name="province"
              :reduce="(x) => ({ provinceId: x.id, provinceName: x.name })"
              ref="provinceListSelect"
              @input="selectProvince"
              :clearable="false"
              dir="rtl"
            >
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('province')">{{
              errors.first("province")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/2 sm:w-1/2 w-full">
            <label class="vs-select--label">{{ $t("City") }}</label>
            <v-select
              label="name"
              name="city"
              v-model="city"
              :options="allCities"
              :reduce="(x) => ({ cityId: x.id, cityName: x.name })"
              v-validate="{ required: true }"
              :clearable="true"
              ref="cityListSelect"
              @input="selectCity"
              :disabled="cityDisable"
              dir="rtl"
            >
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('city')">{{
              errors.first("city")
            }}</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col lg:w-1/2 sm:w-1/2 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-model="model.recipient.addressInfo.postalCode"
              name="postalCode"
              :label="$t('PostalCode')"
              v-validate="{
                regex: '^([0-9]+)$',
                required: 'true',
                digits: '10',
              }"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('postalCode')"
              >{{ errors.first("postalCode") }}</span
            >
          </div>
          <div class="vx-col lg:w-1/2 sm:w-1/2 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-model="model.recipient.mobileNumber"
              name="mobileNumber"
              :label="$t('MobileNumber')"
              v-validate="{ regex: '^([0-9]+)$', required: 'true' }"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('mobileNumber')"
              >{{ errors.first("mobileNumber") }}</span
            >
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-textarea
              class="inputx mb-2"
              v-model="model.recipient.addressInfo.address"
              name="address"
              :label="$t('Address')"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('address')">{{
              errors.first("address")
            }}</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button
              type="filled"
              class="float-right mt-2"
              @click.prevent="submitForm"
              :disabled="disabled"
              >{{ $t("Save") }}</vs-button
            >
          </div>
        </div>
      </form>
      <div class="vx-row">
        <div class="vx-col w-full">
          <div
            class="recipient-list transferee-options"
            v-for="(recipient, index) in recipients"
            :key="index"
          >
            <div class="w-full recipient-item" v-if="refresh">
              <div class="wrapper">
                <span class="ttl w-full">
                  <strong>تحویل گیرنده: </strong>
                  <span> {{ recipient.fullName }} </span>
                  <vs-button
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-edit"
                    class="mr-4 bg_l_blue float-right"
                    @click="editRecipient(recipient)"
                    >{{ $t("Edit") }}</vs-button
                  >
                </span>
                <span class="w-full">
                  <strong>آدرس: </strong>
                  <span>
                    {{ recipient.addressInfo.province.name }}-{{
                      recipient.addressInfo.province.cityName
                    }}-{{ recipient.addressInfo.address }}-<strong
                      >کدپستی:</strong
                    >
                    {{ recipient.addressInfo.postalCode }}
                  </span>
                </span>
                <span class="w-full">
                  <strong> شماره تلفن: </strong>
                  <span>{{ recipient.phoneNumber }}</span>
                  <strong> شماره موبایل: </strong>
                  <span>{{ recipient.mobileNumber }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row mt-6" v-if="!addNewInfo && recipients.length == 0">
        <div class="vx-col w-full">
          <div class="no-info">اطلاعات تحویل گیرنده وارد نشده است!</div>
        </div>
      </div>
      <div class="loadingsec" v-if="showLoading">
        <svg
          class="spinner"
          width="65px"
          height="65px"
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            class="path"
            fill="none"
            stroke-width="6"
            stroke-linecap="round"
            cx="33"
            cy="33"
            r="30"
          ></circle>
        </svg>
      </div>
      <recipient-modify-popup
        :show="recipientPopup"
        :model="recipientModel"
        :ownerUserId="ownerUserId"
        :ownerUserName="ownerUserName"
        @finish="onfinish"
        @close="closeRecipientPopup"
      ></recipient-modify-popup>
    </div>
  </div>
</template>
<style lang="scss">
.vs-con-textarea h4 {
  margin-bottom: 0.25rem !important;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "vue-select";
import RecipientModifyPopup from "./RecipientModifyPopup.vue";
const dict = {
  custom: {
    fullName: {
      required: "لطفا نام و نام خانوادگی تحویل گیرنده را وارد نمایید.",
    },
    phoneNumber: {
      required: "لطفا شماره تلفن تحویل گیرنده را وارد نمایید.",
      regex: "شماره تلفن نامعتبر می باشد",
    },
    mobileNumber: {
      required: "لطفا شماره موبایل تحویل گیرنده را وارد نمایید.",
      regex: "شماره موبایل نامعتبر می باشد",
    },
    city: {
      required: "لطفا شهر تحویل گیرنده را وارد نمایید.",
    },
    postalCode: {
      required: "لطفا کدپستی تحویل گیرنده را وارد نمایید.",
      regex: "کدپستی نامعتبر می باشد",
      digits: "لطفا کدپستی تحویل گیرنده را وارد نمایید.",
    },
    address: {
      required: "لطفا آدرس تحویل گیرنده را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  data() {
    return {
      // permission85: "",
      recipientPopup: false,
      addNewInfo: false,
      city: "",
      disabled: false,
      cityDisable: true,
      recipientModel: {},
      ownerUserName: "",
      model: {
        ownerUserId: null,
        ownerUserName: "",
        recipient: {
          id: 0,
          ssn: "",
          no: "",
          unit: 0,
          fullName: "",
          phoneNumber: "",
          mobileNumber: "",
          addressInfo: {
            province: {
              id: null,
              name: "",
              cityId: null,
              cityName: "",
            },
            address: "",
            postalCode: "",
          },
          longitude: "",
          latitude: "",
          recipientType: 2,
          agentId: this.$route.params.id,
        },
      },
      ownerUserId: null,
      showLoading: false,
      recipients: [],
      refresh: true,
      Ids: {},
    };
  },
  computed: {
    ...mapGetters({
      allProvinces: "country/provinceList",
      allCities: "country/cityList",
      agnet: "parties/agentDetails",
      mainRecipients: "recipientsShipping/agentRecipients",
    }),
  },
  mounted() {
    this.fetchProvinces();
    this.load();
  },
  methods: {
    ...mapActions({
      fetchProvinces: "country/fetchProvinces",
      fetchCitiesById: "country/fetchCitiesById",
      addAgentRecipients: "recipientsShipping/addAgentRecipients",
      fetchSingleAgent: "parties/fetchSingleAgent",
      fetchAgentRecipients: "recipientsShipping/fetchAgentRecipients",
    }),
    load() {
      this.showLoading = true;
      // var id = this.$route.params.id;
      // this.fetchSingleAgent(id).then(() => {
      //   this.model.ownerUserId = this.agnet.agentOwnerQuery.ownerId;
      //   this.model.ownerUserName = this.agnet.agentOwnerQuery.agentOwnerName;
      //   this.Ids.ownerUserId = this.agnet.agentOwnerQuery.ownerId;
      //   this.Ids.agentId = this.agnet.id;
      this.Ids.ownerUserId = this.$route.query.ownerUserId;
      this.Ids.agentId = this.$route.params.id;
      this.model.ownerUserId = this.$route.query.ownerUserId;
      this.model.ownerUserName = this.$route.query.ownerUserName;
      this.fetchAgentRecipients(this.Ids).then(() => {
        this.recipients = this.mainRecipients;
        this.showLoading = false;
      });
      // });
    },
    selectProvince(province) {
      if (province) {
        this.cityDisable = true;
        this.model.recipient.addressInfo.province.id = province.provinceId;
        this.model.recipient.addressInfo.province.name = province.provinceName;
        this.model.recipient.addressInfo.province.cityId = "";
        this.model.recipient.addressInfo.province.cityName = "";
        this.fetchCitiesById(province.provinceId).then(() => {
          this.cityDisable = false;
        });
        if (this.$refs.cityListSelect) {
          this.$refs.cityListSelect.clearSelection();
        }
        if (this.model.recipient.addressInfo.province.cityId) {
          this.model.recipient.addressInfo.province.cityId = "";
          this.model.recipient.addressInfo.province.cityName = "";
        }
      }
    },
    selectCity(city) {
      if (city) {
        this.model.recipient.addressInfo.province.cityId = city.cityId;
        this.model.recipient.addressInfo.province.cityName = city.cityName;
      }
    },
    editRecipient(model) {
      this.recipientPopup = true;
      this.recipientModel = JSON.parse(JSON.stringify(model));
      this.ownerUserId = this.$route.query.ownerUserId;
      this.ownerUserName = this.$route.query.ownerUserName;
    },
    closeRecipientPopup() {
      this.recipientPopup = false;
    },
    onfinish() {
      this.showLoading = true;
      this.refresh = false;
      this.fetchAgentRecipients(this.agnet.agentOwnerQuery.ownerId).then(() => {
        setTimeout(() => {
          this.recipients = this.mainRecipients;
          this.showLoading = false;
          this.refresh = true;
        }, 1500);
      });
      this.closeRecipientPopup;
    },
    submitForm() {
      var routeParams = {
        ownerUserId: this.model.ownerUserId,
        agentId: this.Ids.agentId,
      };
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.disabled = true;
          this.addAgentRecipients(this.model).then(() => {
            this.showLoading = true;
            this.recipients = null;
            // this.agnet.agentOwnerQuery.ownerId
            this.fetchAgentRecipients(routeParams).then(() => {
              this.showLoading = false;
              this.recipients = this.mainRecipients;
              this.model.recipient = {
                id: 0,
                ssn: "",
                no: "",
                unit: 0,
                fullName: "",
                phoneNumber: "",
                mobileNumber: "",
                addressInfo: {
                  province: {
                    id: null,
                    name: "",
                    cityId: null,
                    cityName: "",
                  },
                  address: "",
                  postalCode: "",
                },
                longitude: "",
                latitude: "",
                recipientType: 2,
              };
              this.$refs.provinceListSelect.clearSelection();
              this.$refs.cityListSelect.clearSelection();
              this.$validator.reset();
              this.addNewInfo = false;
            });
          });
          this.disabled = false;
        } else {
          // form have errors
          this.$swal({
            position: "center-center",
            type: "error",
            text: "خطا",
            showConfirmButton: false,
            timer: 8000,
          });
          this.disabled = false;
        }
      });
    },
  },
  components: {
    "v-select": vSelect,
    RecipientModifyPopup,
  },
};
</script>
